// extracted by mini-css-extract-plugin
export default {"container":"GW-z","title":"HW-z","link":"IW-z"};